<script>
import { watch } from 'vue';
import pdfMake from 'pdfmake/build/pdfmake';
import { pdfFileName, pdfDateRange, openPdf } from '@/utils/pdfFile';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import moment from 'moment';
import CompanyBalance from '@/services/CompanyBalanceService';

export default {
  props: {
    company_id: Number,
    company_name: String,
    trigger: Number,
    filters: Object, // { category, startDate, endDate }
  },
  setup(props, { emit }) {
    const loadPdf = async () => {
      try {
        const response = await CompanyBalance.getCategoryTransactionsPdf(props.company_id, props.filters || {});
        const data = response.data || {};
        const rows = data.transactions || [];

        if (!rows.length) {
          emit('alertEvent', 'no_data');
          return;
        }

        const body = [
          [
            { text: '#', style: 'th', alignment: 'center' },
            { text: 'Date', style: 'th', alignment: 'center' },
            { text: 'Category', style: 'th', alignment: 'center' },
            { text: 'Description', style: 'th', alignment: 'left' },
            { text: 'Amount', style: 'th', alignment: 'right' },
          ],
        ];

        let i = 1;
        rows.forEach((row) => {
          body.push([
            { text: i.toString(), style: 'td', alignment: 'center' },
            { text: row.payment_at ? moment(row.payment_at).format('DD/MM/YY') : '', style: 'td', alignment: 'center' },
            { text: (row.category || '').toString(), style: 'td', alignment: 'center' },
            { text: (row.description || '').toString(), style: 'td', alignment: 'left' },
            { text: Number(row.amount || 0).toFixed(2), style: 'td', alignment: 'right' },
          ]);
          i += 1;
        });

        // Total row
        body.push([
          { text: 'TOTAL', style: 'total', colSpan: 4, alignment: 'left' }, {}, {}, {},
          { text: Number(data.total || 0).toFixed(2), style: 'total', alignment: 'right' },
        ]);

        const f = props.filters || {};
        const catLabel = f.category && f.category !== 'all' ? f.category : 'All';
        const dateLabel = (f.startDate || f.endDate)
          ? `${f.startDate ? moment(f.startDate).format('DD/MM/YY') : '...'} - ${f.endDate ? moment(f.endDate).format('DD/MM/YY') : '...'}`
          : 'All dates';

        const documentDefinition = {
          content: [
            {
              columns: [
                { width: '60%', text: (props.company_name || 'Company') + ' - Claims / Commission', style: ['heading', 'mb2'] },
                { width: '40%', text: 'Print Date: ' + moment().format('DD/MM/YY'), style: ['heading', 'textRight', 'mb2'] },
              ],
            },
            {
              columns: [
                { width: '60%', text: 'Category: ' + catLabel, style: ['sub', 'mb10'] },
                { width: '40%', text: 'Period: ' + dateLabel, style: ['sub', 'textRight', 'mb10'] },
              ],
            },
            {
              table: {
                headerRows: 1,
                widths: [25, 60, 70, '*', 70],
                body,
              },
            },
          ],
          styles: {
            heading: { fontSize: 12, bold: true },
            sub: { fontSize: 9 },
            th: { fontSize: 9, bold: true },
            td: { fontSize: 9 },
            total: { fontSize: 10, bold: true },
            textRight: { alignment: 'right' },
            mb2: { margin: [0, 0, 0, 2] },
            mb10: { margin: [0, 0, 0, 10] },
          },
        };

        pdfMake.vfs = pdfFonts;
        openPdf(pdfMake, documentDefinition, pdfFileName(['Company-Claims', props.company_name], pdfDateRange((props.filters || {}).startDate, (props.filters || {}).endDate)));
      } catch (error) {
        emit('alertEvent', 'no_data');
      }
    };

    watch(
      () => props.trigger,
      (currentValue, previousValue) => {
        if (currentValue !== previousValue) {
          loadPdf();
        }
      }
    );

    return { loadPdf };
  },
};
</script>
